import { Icon, Text } from 'bold-ui'
import { SimNaoEnum } from 'components/form'
import { MChatPerguntaEnum, MChatRiscoEnum } from 'graphql/types.generated'
import React, { ReactNode } from 'react'

import { MChatAnteriorFooterInfoModel } from '../mchat/model-mchat'
import { MChatRfResultadoStatus } from '../model-mChatRf'
import { ConsultaSeguimentoPerguntaStatusLabel } from './components/ConsultaSeguimentoPerguntaStatusLabel'
import {
  ConsultaSeguimentoPerguntaStatusTag,
  ConsultaSeguimentoPerguntaStatusTagEnum,
} from './components/ConsultaSeguimentoPerguntaStatusTag'
import { ConsultaSeguimentoStatusRespondendoIcon } from './components/ConsultaSeguimentoStatusRespondendoIcon'
import { ConsultaSeguimentoPergunta01Model } from './perguntas/consulta-seguimento-pergunta-01/model-consultaSeguimentoPergunta01'
import { ConsultaSeguimentoPergunta02Model } from './perguntas/consulta-seguimento-pergunta-02/model-consultaSeguimentoPergunta02'
import { ConsultaSeguimentoPergunta03Model } from './perguntas/consulta-seguimento-pergunta-03/model-consultaSeguimentoPergunta03'
import { ConsultaSeguimentoPergunta04Model } from './perguntas/consulta-seguimento-pergunta-04/model-consultaSeguimentoPergunta04'
import { ConsultaSeguimentoPergunta05Model } from './perguntas/consulta-seguimento-pergunta-05/model-consultaSeguimentoPergunta05'
import { ConsultaSeguimentoPergunta06Model } from './perguntas/consulta-seguimento-pergunta-06/model-consultaSeguimentoPergunta06'
import { ConsultaSeguimentoPergunta07Model } from './perguntas/consulta-seguimento-pergunta-07/model-consultaSeguimentoPergunta07'
import { ConsultaSeguimentoPergunta08Model } from './perguntas/consulta-seguimento-pergunta-08/model-consultaSeguimentoPergunta08'
import { ConsultaSeguimentoPergunta09Model } from './perguntas/consulta-seguimento-pergunta-09/model-consultaSeguimentoPergunta09'
import { ConsultaSeguimentoPergunta10Model } from './perguntas/consulta-seguimento-pergunta-10/model-consultaSeguimentoPergunta10'
import { ConsultaSeguimentoPergunta11Model } from './perguntas/consulta-seguimento-pergunta-11/model-consultaSeguimentoPergunta11'
import { ConsultaSeguimentoPergunta12Model } from './perguntas/consulta-seguimento-pergunta-12/model-consultaSeguimentoPergunta12'
import { ConsultaSeguimentoPergunta13Model } from './perguntas/consulta-seguimento-pergunta-13/model-consultaSeguimentoPergunta13'
import { ConsultaSeguimentoPergunta14Model } from './perguntas/consulta-seguimento-pergunta-14/model-consultaSeguimentoPergunta14'
import { ConsultaSeguimentoPergunta15Model } from './perguntas/consulta-seguimento-pergunta-15/model-consultaSeguimentoPergunta15'
import { ConsultaSeguimentoPergunta16Model } from './perguntas/consulta-seguimento-pergunta-16/model-consultaSeguimentoPergunta16'
import { ConsultaSeguimentoPergunta17Model } from './perguntas/consulta-seguimento-pergunta-17/model-consultaSeguimentoPergunta17'
import { ConsultaSeguimentoPergunta18Model } from './perguntas/consulta-seguimento-pergunta-18/model-consultaSeguimentoPergunta18'
import { ConsultaSeguimentoPergunta19Model } from './perguntas/consulta-seguimento-pergunta-19/model-consultaSeguimentoPergunta19'
import { ConsultaSeguimentoPergunta20Model } from './perguntas/consulta-seguimento-pergunta-20/model-consultaSeguimentoPergunta20'

export const CONSULTA_SEGUIMENTO_URL_MODAL = '/entrevista-seguimento'

export enum ConsultaSeguimentoModalTab {
  SELECAO = 'SELECAO',
  APLICACAO = 'APLICACAO',
  RESULTADO = 'RESULTADO',
}

export enum PassouFalhouEnum {
  PASSOU = 'PASSOU',
  FALHOU = 'FALHOU',
}

export enum PodeNaoPodeEnum {
  PODE = 'PODE',
  NAO_PODE = 'NAO_PODE',
}

export enum ConsultaSeguimentoResultadoEnum {
  RASTREAMENTO_POSITIVO = 'RASTREAMENTO_POSITIVO',
  RASTREAMENTO_NEGATIVO = 'RASTREAMENTO_NEGATIVO',
}

export enum ConsultaSeguimentoPerguntaStatusEnum {
  NAO_DISPONIVEL = 'NAO_DISPONIVEL',
  DISPONIVEL = 'DISPONIVEL',
  RESPONDENDO = 'RESPONDENDO',
  RESPONDENDO_PASSOU = 'RESPONDENDO_PASSOU',
  RESPONDENDO_FALHOU = 'RESPONDENDO_FALHOU',
  FINALIZADO_PASSOU = 'FINALIZADO_PASSOU',
  FINALIZADO_FALHOU = 'FINALIZADO_FALHOU',
}

export interface ConsultaSeguimentoSelectionState {
  failed: boolean
  values: MChatPerguntaEnum[]
}

export interface ConsultaSeguimentoFieldModel {
  aplicacao: ConsultaSeguimentoAplicacaoModel
  perguntasSelecionadas: MChatPerguntaEnum[]
  resultado?: ConsultaSeguimentoResultadoEnum
}

export interface ConsultaSeguimentoViewModel {
  resultado: ConsultaSeguimentoResultadoEnum
  totalPerguntasRespondidas: number
  totalPerguntasFalhou: number
  totalPerguntasPassou: number
  footerInfo?: MChatAnteriorFooterInfoModel
}

export interface ImpressaoConsultaSeguimento {
  atendProfId: string
  cidadaoId: string
  resultadoSeguimento: ConsultaSeguimentoResultadoEnum
  totalPerguntasRespondidas: number
  totalPerguntasFalhou: number
  totalPerguntasPassou: number
}

export type ConsultaSeguimentoAplicacaoItemModel = {
  resultado?: PassouFalhouEnum
  status: ConsultaSeguimentoPerguntaStatusEnum
}

export type ConsultaSeguimentoOutroFieldModel = {
  textValue: string
  radioValue: SimNaoEnum
}

export type ConsultaSeguimentoAplicacaoModel = Partial<{
  [MChatPerguntaEnum.PERGUNTA_01]: ConsultaSeguimentoPergunta01Model
  [MChatPerguntaEnum.PERGUNTA_02]: ConsultaSeguimentoPergunta02Model
  [MChatPerguntaEnum.PERGUNTA_03]: ConsultaSeguimentoPergunta03Model
  [MChatPerguntaEnum.PERGUNTA_04]: ConsultaSeguimentoPergunta04Model
  [MChatPerguntaEnum.PERGUNTA_05]: ConsultaSeguimentoPergunta05Model
  [MChatPerguntaEnum.PERGUNTA_06]: ConsultaSeguimentoPergunta06Model
  [MChatPerguntaEnum.PERGUNTA_07]: ConsultaSeguimentoPergunta07Model
  [MChatPerguntaEnum.PERGUNTA_08]: ConsultaSeguimentoPergunta08Model
  [MChatPerguntaEnum.PERGUNTA_09]: ConsultaSeguimentoPergunta09Model
  [MChatPerguntaEnum.PERGUNTA_10]: ConsultaSeguimentoPergunta10Model
  [MChatPerguntaEnum.PERGUNTA_11]: ConsultaSeguimentoPergunta11Model
  [MChatPerguntaEnum.PERGUNTA_12]: ConsultaSeguimentoPergunta12Model
  [MChatPerguntaEnum.PERGUNTA_13]: ConsultaSeguimentoPergunta13Model
  [MChatPerguntaEnum.PERGUNTA_14]: ConsultaSeguimentoPergunta14Model
  [MChatPerguntaEnum.PERGUNTA_15]: ConsultaSeguimentoPergunta15Model
  [MChatPerguntaEnum.PERGUNTA_16]: ConsultaSeguimentoPergunta16Model
  [MChatPerguntaEnum.PERGUNTA_17]: ConsultaSeguimentoPergunta17Model
  [MChatPerguntaEnum.PERGUNTA_18]: ConsultaSeguimentoPergunta18Model
  [MChatPerguntaEnum.PERGUNTA_19]: ConsultaSeguimentoPergunta19Model
  [MChatPerguntaEnum.PERGUNTA_20]: ConsultaSeguimentoPergunta20Model
}>

export type ConsultaSeguimentoAplicacaoStatsModel = {
  totalPerguntasFalhou: number
  totalPerguntasPassou: number
  totalPerguntasRespondidas: number
}

export const ConsultaSeguimentoPerguntaStatusMap: Record<
  ConsultaSeguimentoPerguntaStatusEnum,
  { icon: React.ReactNode; label?: React.ReactNode }
> = {
  NAO_DISPONIVEL: {
    icon: <Icon icon='questionMarkFilled' fill='disabled' size={1} />,
  },
  DISPONIVEL: {
    icon: <Icon icon='questionMarkFilled' fill='secondary' size={1} />,
    label: <ConsultaSeguimentoPerguntaStatusLabel label='Pronta para responder' />,
  },
  RESPONDENDO: {
    icon: <ConsultaSeguimentoStatusRespondendoIcon />,
    label: <ConsultaSeguimentoPerguntaStatusLabel label='Continue respondendo' />,
  },
  RESPONDENDO_PASSOU: {
    icon: <Icon icon='checkCircleFilled' fill='success' size={1} />,
    label: <ConsultaSeguimentoPerguntaStatusTag type={ConsultaSeguimentoPerguntaStatusTagEnum.PASSOU} />,
  },
  RESPONDENDO_FALHOU: {
    icon: <Icon icon='timesFilled' fill='danger' size={1} />,
    label: <ConsultaSeguimentoPerguntaStatusTag type={ConsultaSeguimentoPerguntaStatusTagEnum.FALHOU} />,
  },
  FINALIZADO_PASSOU: {
    icon: <Icon icon='checkCircleFilled' fill='success' size={1} />,
    label: (
      <ConsultaSeguimentoPerguntaStatusLabel label='Passou' status={ConsultaSeguimentoPerguntaStatusTagEnum.PASSOU} />
    ),
  },
  FINALIZADO_FALHOU: {
    icon: <Icon icon='timesFilled' fill='danger' size={1} />,
    label: (
      <ConsultaSeguimentoPerguntaStatusLabel label='Falhou' status={ConsultaSeguimentoPerguntaStatusTagEnum.FALHOU} />
    ),
  },
}

export const ConsultaSeguimentoResultadoMap: Record<
  ConsultaSeguimentoResultadoEnum,
  { status: MChatRfResultadoStatus; title: string; encaminhamento: ReactNode }
> = {
  RASTREAMENTO_NEGATIVO: {
    status: 'success',
    title: 'Rastreamento negativo',
    encaminhamento: (
      <Text color='inherit'>
        <strong>Nenhuma outra medida é necessária, a não ser que a vigilância indique risco de TEA.</strong> A criança
        deverá fazer a triagem novamente em futuras consultas de rotina.
      </Text>
    ),
  },
  RASTREAMENTO_POSITIVO: {
    status: 'danger',
    title: 'Rastreamento positivo',
    encaminhamento: (
      <Text color='inherit' fontWeight='bold'>
        É altamente recomendado que a criança seja encaminhada para a intervenção precoce e testagem diagnóstica o mais
        breve possível.
      </Text>
    ),
  },
}

export const ConsultaSeguimentoPassouFalhouMap: Record<PassouFalhouEnum, { title: string }> = {
  FALHOU: {
    title: 'Falhou',
  },
  PASSOU: {
    title: 'Passou',
  },
}

export const MChatRiscoToConsultaSeguimentoResultado: Partial<Record<
  MChatRiscoEnum,
  ConsultaSeguimentoResultadoEnum
>> = {
  BAIXO: ConsultaSeguimentoResultadoEnum.RASTREAMENTO_NEGATIVO,
  ELEVADO: ConsultaSeguimentoResultadoEnum.RASTREAMENTO_POSITIVO,
}

export const ConsultaSeguimentoPerguntaToSubPergunta: Partial<Record<MChatPerguntaEnum, Set<MChatPerguntaEnum>>> = {
  [MChatPerguntaEnum.PERGUNTA_01]: new Set([
    MChatPerguntaEnum.PERGUNTA_01_01,
    MChatPerguntaEnum.PERGUNTA_01_02,
    MChatPerguntaEnum.PERGUNTA_01_03,
    MChatPerguntaEnum.PERGUNTA_01_04,
    MChatPerguntaEnum.PERGUNTA_01_05,
    MChatPerguntaEnum.PERGUNTA_01_06,
    MChatPerguntaEnum.PERGUNTA_01_07,
    MChatPerguntaEnum.PERGUNTA_01_08,
    MChatPerguntaEnum.PERGUNTA_01_09,
  ]),
  [MChatPerguntaEnum.PERGUNTA_02]: new Set([
    MChatPerguntaEnum.PERGUNTA_02_01,
    MChatPerguntaEnum.PERGUNTA_02_02,
    MChatPerguntaEnum.PERGUNTA_02_03,
    MChatPerguntaEnum.PERGUNTA_02_04,
  ]),
  [MChatPerguntaEnum.PERGUNTA_03]: new Set([
    MChatPerguntaEnum.PERGUNTA_03_01,
    MChatPerguntaEnum.PERGUNTA_03_02,
    MChatPerguntaEnum.PERGUNTA_03_03,
    MChatPerguntaEnum.PERGUNTA_03_04,
    MChatPerguntaEnum.PERGUNTA_03_05,
    MChatPerguntaEnum.PERGUNTA_03_06,
    MChatPerguntaEnum.PERGUNTA_03_07,
    MChatPerguntaEnum.PERGUNTA_03_08,
    MChatPerguntaEnum.PERGUNTA_03_09,
    MChatPerguntaEnum.PERGUNTA_03_10,
    MChatPerguntaEnum.PERGUNTA_03_11,
    MChatPerguntaEnum.PERGUNTA_03_12,
  ]),
  [MChatPerguntaEnum.PERGUNTA_04]: new Set([
    MChatPerguntaEnum.PERGUNTA_04_01,
    MChatPerguntaEnum.PERGUNTA_04_02,
    MChatPerguntaEnum.PERGUNTA_04_03,
    MChatPerguntaEnum.PERGUNTA_04_04,
    MChatPerguntaEnum.PERGUNTA_04_05,
  ]),
  [MChatPerguntaEnum.PERGUNTA_05]: new Set([
    MChatPerguntaEnum.PERGUNTA_05_01,
    MChatPerguntaEnum.PERGUNTA_05_02,
    MChatPerguntaEnum.PERGUNTA_05_03,
    MChatPerguntaEnum.PERGUNTA_05_04,
    MChatPerguntaEnum.PERGUNTA_05_05,
    MChatPerguntaEnum.PERGUNTA_05_06,
    MChatPerguntaEnum.PERGUNTA_05_07,
    MChatPerguntaEnum.PERGUNTA_05_08,
    MChatPerguntaEnum.PERGUNTA_05_09,
  ]),
  [MChatPerguntaEnum.PERGUNTA_06]: new Set([
    MChatPerguntaEnum.PERGUNTA_06_01,
    MChatPerguntaEnum.PERGUNTA_06_02,
    MChatPerguntaEnum.PERGUNTA_06_03,
    MChatPerguntaEnum.PERGUNTA_06_04,
    MChatPerguntaEnum.PERGUNTA_06_05,
    MChatPerguntaEnum.PERGUNTA_06_06,
  ]),
  [MChatPerguntaEnum.PERGUNTA_07]: new Set([
    MChatPerguntaEnum.PERGUNTA_07_01,
    MChatPerguntaEnum.PERGUNTA_07_02,
    MChatPerguntaEnum.PERGUNTA_07_03,
    MChatPerguntaEnum.PERGUNTA_07_04,
    MChatPerguntaEnum.PERGUNTA_07_05,
    MChatPerguntaEnum.PERGUNTA_07_06,
    MChatPerguntaEnum.PERGUNTA_07_07,
  ]),
  [MChatPerguntaEnum.PERGUNTA_08]: new Set([
    MChatPerguntaEnum.PERGUNTA_08_01,
    MChatPerguntaEnum.PERGUNTA_08_02,
    MChatPerguntaEnum.PERGUNTA_08_03,
    MChatPerguntaEnum.PERGUNTA_08_04,
    MChatPerguntaEnum.PERGUNTA_08_05,
    MChatPerguntaEnum.PERGUNTA_08_06,
    MChatPerguntaEnum.PERGUNTA_08_07,
    MChatPerguntaEnum.PERGUNTA_08_08,
    MChatPerguntaEnum.PERGUNTA_08_09,
    MChatPerguntaEnum.PERGUNTA_08_10,
    MChatPerguntaEnum.PERGUNTA_08_11,
  ]),
  [MChatPerguntaEnum.PERGUNTA_09]: new Set([
    MChatPerguntaEnum.PERGUNTA_09_01,
    MChatPerguntaEnum.PERGUNTA_09_02,
    MChatPerguntaEnum.PERGUNTA_09_03,
    MChatPerguntaEnum.PERGUNTA_09_04,
    MChatPerguntaEnum.PERGUNTA_09_05,
    MChatPerguntaEnum.PERGUNTA_09_06,
    MChatPerguntaEnum.PERGUNTA_09_07,
    MChatPerguntaEnum.PERGUNTA_09_08,
  ]),
  [MChatPerguntaEnum.PERGUNTA_10]: new Set([
    MChatPerguntaEnum.PERGUNTA_10_01,
    MChatPerguntaEnum.PERGUNTA_10_02,
    MChatPerguntaEnum.PERGUNTA_10_03,
    MChatPerguntaEnum.PERGUNTA_10_04,
    MChatPerguntaEnum.PERGUNTA_10_05,
    MChatPerguntaEnum.PERGUNTA_10_06,
    MChatPerguntaEnum.PERGUNTA_10_07,
    MChatPerguntaEnum.PERGUNTA_10_08,
    MChatPerguntaEnum.PERGUNTA_10_09,
  ]),
  [MChatPerguntaEnum.PERGUNTA_11]: new Set([
    MChatPerguntaEnum.PERGUNTA_11_01,
    MChatPerguntaEnum.PERGUNTA_11_02,
    MChatPerguntaEnum.PERGUNTA_11_03,
    MChatPerguntaEnum.PERGUNTA_11_04,
    MChatPerguntaEnum.PERGUNTA_11_05,
    MChatPerguntaEnum.PERGUNTA_11_06,
    MChatPerguntaEnum.PERGUNTA_11_07,
    MChatPerguntaEnum.PERGUNTA_11_08,
  ]),
  [MChatPerguntaEnum.PERGUNTA_12]: new Set([
    MChatPerguntaEnum.PERGUNTA_12_01,
    MChatPerguntaEnum.PERGUNTA_12_02,
    MChatPerguntaEnum.PERGUNTA_12_03,
    MChatPerguntaEnum.PERGUNTA_12_04,
    MChatPerguntaEnum.PERGUNTA_12_05,
    MChatPerguntaEnum.PERGUNTA_12_06,
    MChatPerguntaEnum.PERGUNTA_12_07,
    MChatPerguntaEnum.PERGUNTA_12_08,
    MChatPerguntaEnum.PERGUNTA_12_09,
    MChatPerguntaEnum.PERGUNTA_12_10,
    MChatPerguntaEnum.PERGUNTA_12_11,
    MChatPerguntaEnum.PERGUNTA_12_12,
    MChatPerguntaEnum.PERGUNTA_12_13,
    MChatPerguntaEnum.PERGUNTA_12_14,
    MChatPerguntaEnum.PERGUNTA_12_15,
    MChatPerguntaEnum.PERGUNTA_12_16,
    MChatPerguntaEnum.PERGUNTA_12_17,
    MChatPerguntaEnum.PERGUNTA_12_18,
  ]),
  [MChatPerguntaEnum.PERGUNTA_13]: new Set([MChatPerguntaEnum.PERGUNTA_13_01, MChatPerguntaEnum.PERGUNTA_13_02]),
  [MChatPerguntaEnum.PERGUNTA_14]: new Set([
    MChatPerguntaEnum.PERGUNTA_14_01,
    MChatPerguntaEnum.PERGUNTA_14_02,
    MChatPerguntaEnum.PERGUNTA_14_03,
    MChatPerguntaEnum.PERGUNTA_14_04,
    MChatPerguntaEnum.PERGUNTA_14_05,
    MChatPerguntaEnum.PERGUNTA_14_06,
    MChatPerguntaEnum.PERGUNTA_14_07,
    MChatPerguntaEnum.PERGUNTA_14_08,
    MChatPerguntaEnum.PERGUNTA_14_09,
    MChatPerguntaEnum.PERGUNTA_14_10,
  ]),
  [MChatPerguntaEnum.PERGUNTA_15]: new Set([
    MChatPerguntaEnum.PERGUNTA_15_01,
    MChatPerguntaEnum.PERGUNTA_15_02,
    MChatPerguntaEnum.PERGUNTA_15_03,
    MChatPerguntaEnum.PERGUNTA_15_04,
    MChatPerguntaEnum.PERGUNTA_15_05,
    MChatPerguntaEnum.PERGUNTA_15_06,
    MChatPerguntaEnum.PERGUNTA_15_07,
    MChatPerguntaEnum.PERGUNTA_15_08,
  ]),
  [MChatPerguntaEnum.PERGUNTA_16]: new Set([
    MChatPerguntaEnum.PERGUNTA_16_01,
    MChatPerguntaEnum.PERGUNTA_16_02,
    MChatPerguntaEnum.PERGUNTA_16_03,
    MChatPerguntaEnum.PERGUNTA_16_04,
    MChatPerguntaEnum.PERGUNTA_16_05,
    MChatPerguntaEnum.PERGUNTA_16_06,
    MChatPerguntaEnum.PERGUNTA_16_07,
  ]),
  [MChatPerguntaEnum.PERGUNTA_17]: new Set([
    MChatPerguntaEnum.PERGUNTA_17_01,
    MChatPerguntaEnum.PERGUNTA_17_02,
    MChatPerguntaEnum.PERGUNTA_17_03,
    MChatPerguntaEnum.PERGUNTA_17_04,
    MChatPerguntaEnum.PERGUNTA_17_05,
    MChatPerguntaEnum.PERGUNTA_17_06,
  ]),
  [MChatPerguntaEnum.PERGUNTA_18]: new Set([
    MChatPerguntaEnum.PERGUNTA_18_01,
    MChatPerguntaEnum.PERGUNTA_18_02,
    MChatPerguntaEnum.PERGUNTA_18_03,
    MChatPerguntaEnum.PERGUNTA_18_04,
    MChatPerguntaEnum.PERGUNTA_18_05,
    MChatPerguntaEnum.PERGUNTA_18_06,
    MChatPerguntaEnum.PERGUNTA_18_07,
  ]),
  [MChatPerguntaEnum.PERGUNTA_19]: new Set([
    MChatPerguntaEnum.PERGUNTA_19_01,
    MChatPerguntaEnum.PERGUNTA_19_02,
    MChatPerguntaEnum.PERGUNTA_19_03,
    MChatPerguntaEnum.PERGUNTA_19_04,
  ]),
  [MChatPerguntaEnum.PERGUNTA_20]: new Set([
    MChatPerguntaEnum.PERGUNTA_20_01,
    MChatPerguntaEnum.PERGUNTA_20_02,
    MChatPerguntaEnum.PERGUNTA_20_03,
    MChatPerguntaEnum.PERGUNTA_20_04,
    MChatPerguntaEnum.PERGUNTA_20_05,
    MChatPerguntaEnum.PERGUNTA_20_06,
  ]),
}
